import { useNavigate } from 'react-router-dom';
import { PageLayout } from '@/components/shared/PageLayout';
import { ContactIntro } from '@/app/contact/components/ContactIntro';
import { ContactFormCard } from '@/app/contact/components/ContactFormCard';
import { useAuth } from '@/features/auth/hooks/useAuth';

const CONTACT_EMAIL = 'ing.toollife@he-arc.ch';

export function ContactPage() {
  const navigate = useNavigate();
  const { tokenService } = useAuth();
  const userEmail = tokenService?.getUserMail() ?? null;

  return (
    <PageLayout
      className="flex-1"
      contentClassName="grid gap-6 xl:grid-cols-[minmax(0,1.15fr)_460px]"
    >
      <ContactIntro />
      <ContactFormCard
        contactEmail={CONTACT_EMAIL}
        userEmail={userEmail}
        onBack={() => navigate(-1)}
      />
    </PageLayout>
  );
}
